export const query = state => {
  return {
    expedient: state.expedient,
    description: state.description,
    amount: state.amount
  }
}
